import { render } from "./PointOuterTable.vue?vue&type=template&id=e768d754"
import script from "./PointOuterTable.vue?vue&type=script&lang=js"
export * from "./PointOuterTable.vue?vue&type=script&lang=js"

import "./PointOuterTable.vue?vue&type=style&index=0&id=e768d754&lang=css"

import exportComponent from "/opt/render/project/src/flint.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__